import * as API from '@/services/api'

export async function fetchBQAParticipantResults(interactionInstanceToken, locale) {
    let query = ''
    if(locale) {
        query = `?locale=${locale}`
    }
    const response = await API.get(`/api/interaction/bq_advisory_wealth/${interactionInstanceToken}/results${query}`)
    return response.data
}

export async function fetchESGResults(interactionInstanceToken) {
    const response = await API.get(`/api/iat/dashboard/esg/${interactionInstanceToken}`)
    return response.data
}